import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinalizacaoAlertaComponent } from './finalizacao-alerta/finalizacao-alerta.component';
import { LoadingModule } from '../libs/loading/loading.module';
import { ButtonAllModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { DebounceClickModule } from '../libs/debounce-click/debounce-click.module';
import { FinalizacaoAlertaConteudoComponent } from './finalizacao-alerta/finalizacao-alerta-conteudo/finalizacao-alerta-conteudo.component';
import { FinalizacaoMenuComponent } from './finalizacao-menu/finalizacao-menu.component';
import { FinalizacaoReaberturaComponent } from './finalizacao-reabertura/finalizacao-reabertura.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';
import { TabAllModule } from '@syncfusion/ej2-angular-navigations';
import { FinalizacaoExecutorComponent } from './finalizacao-executor/finalizacao-executor.component';
import { FinalizacaoConfirmacaoComponent } from './finalizacao-confirmacao/finalizacao-confirmacao.component';
import { FinalizacaoTagComponent } from './finalizacao-tag/finalizacao-tag.component';
import { SMOLinkModule } from '../smolink/smolink.module';
import { FormDialogComponent } from '../shared/form-dialog/form-dialog.component';



@NgModule({
  declarations: [
    FinalizacaoAlertaComponent,
    FinalizacaoAlertaConteudoComponent,
    FinalizacaoMenuComponent,
    FinalizacaoReaberturaComponent,
    FinalizacaoExecutorComponent,
    FinalizacaoConfirmacaoComponent,
    FinalizacaoTagComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoadingModule,
    ButtonAllModule,
    TextBoxAllModule,
    TabAllModule,
    CheckBoxAllModule,
    ErrorHandlerModule,
    DialogAllModule,
    DebounceClickModule,
    SMOLinkModule,
    FormDialogComponent
  ],
  exports: [
    FinalizacaoAlertaComponent,
    FinalizacaoMenuComponent,
    FinalizacaoReaberturaComponent,
    FinalizacaoExecutorComponent,
    FinalizacaoConfirmacaoComponent,
    FinalizacaoTagComponent
  ]
})
export class FinalizacaoModule { }
